export default defineAppConfig({
	ui: {
		primary: 'green',
		white: 'neutral',
	},
})
